/**
 * Convert Float32 audio samples to PCM 16-bit format.
 *
 * @param float32Array - Audio samples in Float32 format (-1.0 to 1.0)
 * @returns ArrayBuffer containing Int16 PCM samples (-32768 to 32767)
 */
export function encodePcm16(float32Array: Float32Array): ArrayBuffer {
  const int16Array = new Int16Array(float32Array.length);

  for (let i = 0; i < float32Array.length; i++) {
    // Clamp to [-1.0, 1.0] to prevent overflow
    const clamped = Math.max(-1.0, Math.min(1.0, float32Array[i]));
    // Convert to Int16 range [-32768, 32767] (asymmetric scaling)
    int16Array[i] = Math.round(clamped < 0 ? clamped * 32768 : clamped * 32767);
  }

  return int16Array.buffer;
}
